<template>
  <div class="w-100 h-100 bg-gray100 d-flex align-items-center justify-content-center">
    <div class="mt-n5 w-25 bg-white rounded-lg p-5 shadow-custom">
      <h5 class="alert-heading">
        {{ $t('reset.title') }}
      </h5>
      <div class="w-100 text-left">
        <b-form @submit="submit">
          <b-form-group>
            <h6 class="font-size-md">
              {{ $t('reset.form.account.label') }}
            </h6>
            <b-form-input
              v-model="form.account.value"
              :placeholder="$t('reset.form.account.placeholder')"
              size="sm"
              type="text"
              class="rounded-pill"
              disabled
            />
          </b-form-group>
          <b-form-group>
            <h6 class="font-size-md">
              <span class="ml-n1 text-danger">*</span>
              {{ $t('reset.form.password.label') }}
            </h6>
            <div class="input-icon input-icon-sm">
              <b-form-input
                v-model="form.password.value"
                :type="form.password.showPassword ? 'text' : 'password'"
                :placeholder="$t('reset.form.password.placeholder')"
                size="sm"
                class="rounded-pill pr-5"
                :class="!form.password.dirty || form.password.valid ? '': 'is-invalid'"
                @focus="onFocus('password')"
                @input="onPwdInput"
                @blur="onBlur('password')"
              />
              <div v-if="form.password.focus" class="input-icon-group">
                <a href="#" tabindex="-1" @mousedown="toggleVisibility('password', $event)">
                  <span class="material-icons font-size-base text-secondary" :class="!form.password.dirty || form.password.valid ? '' : 'mr-3'">
                    {{ form.password.showPassword ? 'visibility_off' : 'visibility' }}
                  </span>
                </a>
              </div>
              <div v-if="form.password.focus && (!form.password.dirty || form.password.valid)" class="mt-1 font-size-sm text-gray600">
                {{ $t('reset.form.password.hint') }}
              </div>
              <div class="invalid-feedback">
                {{ form.password.feedback }}
              </div>
            </div>
          </b-form-group>
          <b-form-group>
            <h6 class="font-size-md">
              <span class="ml-n1 text-danger">*</span>
              {{ $t('reset.form.confirmPassword.label') }}
            </h6>
            <div class="input-icon input-icon-sm">
              <b-form-input
                v-model="form.confirmPassword.value"
                size="sm"
                class="rounded-pill pr-5"
                :class="!form.confirmPassword.dirty || form.confirmPassword.valid ? '': 'is-invalid'"
                :type="form.confirmPassword.showPassword ? 'text' : 'password'"
                :placeholder="$t('reset.form.confirmPassword.placeholder')"
                @focus="onFocus('confirmPassword')"
                @input="onConfirmPwdInput"
                @blur="onBlur('confirmPassword')"
              />
              <div v-if="form.confirmPassword.focus" class="input-icon-group">
                <a href="#" tabindex="-1" @mousedown="toggleVisibility('confirmPassword', $event)">
                  <span class="material-icons font-size-base text-secondary" :class="!form.confirmPassword.dirty || form.confirmPassword.valid ? '' : 'mr-3'">
                    {{ form.confirmPassword.showPassword ? 'visibility_off' : 'visibility' }}
                  </span>
                </a>
              </div>
              <div class="invalid-feedback">
                {{ form.confirmPassword.feedback }}
              </div>
            </div>
          </b-form-group>
          <div class="mt-3 text-center">
            <button type="submit" :disabled="!form.valid" class="mx-1 btn btn-sm btn-primary rounded-pill" @click="submit">
              <span class="px-3">{{ $t('reset.form.submit') }}</span>
            </button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import PermissionService from '@/services/PermissionService';

export default {
  async beforeRouteEnter(to, from, next) {
    if (!to.query.code) {
      next({ path: '/' });
    }
    const user = await PermissionService.GetResetPwdUserAsync(to.query.code);

    if (!user.account) {
      next({ path: '/' });
    } else {
      next((vm) => {
        const instance = vm;
        instance.code = to.query.code;
        instance.user = user;
        instance.form.account.value = user.account;
      });
    }
  },
  data() {
    const vm = this;

    return {
      user: {},
      code: '',
      form: {
        account: {
          value: ''
        },
        password: {
          validate(account) {
            this.valid = this.validation.regex.validation(this.value) && this.validation.accountDuplicate.validation(this.value, account);
          },
          get feedback() {
            return this.validation.regex.feedback || this.validation.accountDuplicate.feedback;
          },
          validation: {
            regex: {
              get feedback() {
                return this.valid ? '' : vm.$t('reset.form.password.feedback.regex');
              },
              validation(val) {
                const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$&()-`.+,/"\d]{8,20}$/g;
                this.valid = regex.test(val);

                return this.valid;
              }
            },
            accountDuplicate: {
              get feedback() {
                return this.valid ? '' : vm.$t('reset.form.password.feedback.accountDuplicate');
              },
              validation(val, account) {
                if (val === null || val === '') {
                  this.valid = true;
                } else if (val === account) {
                  this.valid = false;
                } else {
                  this.valid = true;
                }

                return this.valid;
              },
              valid: true
            }
          },
          dirty: false,
          valid: false,
          value: '',
          focus: false,
          showPassword: false
        },
        confirmPassword: {
          validate(origin) {
            this.valid = this.validation.equal.validation(this.value, origin);
          },
          get feedback() {
            return this.validation.equal.feedback;
          },
          validation: {
            equal: {
              get feedback() {
                return this.valid ? '' : vm.$t('reset.form.confirmPassword.feedback.equal');
              },
              validation(val, origin) {
                this.valid = val === origin;
                return this.valid;
              }
            },
          },
          dirty: false,
          valid: false,
          value: '',
          focus: false,
          showPassword: false
        },
        get valid() {
          return this.password.valid && this.confirmPassword.valid;
        },
        validate() {
          this.password.validate(this.account.value);
          this.confirmPassword.validate(this.password.value);
        }
      }
    };
  },
  methods: {
    // input focus 事件
    onFocus(target) {
      // 設置 input focus 以讓提示出現
      this.form[target].focus = true;
    },
    // 密碼/密碼確認 input blur 事件
    onBlur(target) {
      this.form[target].showPassword = false;
      this.form[target].dirty = true;
      this.form[target].focus = false;
    },
    // 切換密碼顯示
    toggleVisibility(target, event) {
      event.preventDefault();
      this.form[target].showPassword = !this.form[target].showPassword;
    },
    // 密碼輸入事件
    onPwdInput() {
      this.form.password.validate(this.form.account.value);
    },
    // 密碼確認輸入事件
    onConfirmPwdInput() {
      this.form.confirmPassword.validate(this.form.password.value);
    },
    onEmailBlur() {
      this.form.email.validate();
    },
    onEmailInput() {
      this.form.email.validate();
    },
    // 寄出
    submit(event) {
      event.preventDefault();
      const vm = this;

      vm.form.validate();

      if (vm.form.valid) {
        vm.$loading(async () => {
          try {
            await PermissionService.ResetUserPwdAsync({ password: vm.form.password.value, code: vm.code });
            const template = `<h5 class="alert-heading">${vm.$t('reset.resetSuccessfully')}</h5>
                              <p class="text-break-word font-size-md">${vm.$t('reset.redirectToLogin')}</p>`;
            await vm.$popup.alertAsync(template);
            vm.$router.replace({ path: '/' });
          } catch (err) {
            let message = '';

            switch (err.response.status) {
              case 400:
                if (err.response.data.status === '409') {
                  message = vm.$t('reset.redundancy');
                } else if (err.response.data.status === '401') {
                  message = vm.$t('reset.passwordInvalid');
                }
                break;
              case 401:
                message = vm.$t('reset.codeInvalid');
                break;
              default:
                break;
            }

            const template = `<h5 class="alert-heading">${vm.$t('reset.resetFailed')}</h5>
                              <p class="text-break-word font-size-md">${message}</p>`;
            vm.$popup.alert(template);
          }
        });
      }
    }
  }
};
</script>
